export enum TypeEmprunteurEnum {
  Unique = 'unique',
  Coemprunteur1 = 'coemprunteur_principal',
  Coemprunteur2 = 'coemprunteur_secondaire'
}
